'use strict';

function toggleContentTabBlocks(
  $elementToActivate,
  $elementToDisable,
  $blockToShow,
  $blockToHide,
  className
) {
  $elementToActivate.on('click',function () {
    $blockToHide.hide();
    $blockToShow.show();
    $elementToActivate.toggleClass(className, true);
    $elementToDisable.toggleClass(className, false);
  });
}


Shopify.theme.jsContentTabs = {
  init: function init($section) {
    Shopify.theme.jsContentTabs = $.extend(
      this,
      Shopify.theme.getSectionData($section)
    );

    const $contentBlock1 = $section.find('#content-1');
    const $contentBlock2 = $section.find('#content-2');
    const $contentTab1 = $section.find('.content-tabs__tab-1');
    const $contentTab2 = $section.find('.content-tabs__tab-2');

    if (
      $contentBlock1.length &&
      $contentBlock2.length &&
      $contentTab1.length &&
      $contentTab2.length
    ) {
      $contentTab1.addClass('content-tabs__tab--active');
      toggleContentTabBlocks(
        $contentTab1,
        $contentTab2,
        $contentBlock1,
        $contentBlock2,
        'content-tabs__tab--active'
      );
      toggleContentTabBlocks(
        $contentTab2,
        $contentTab1,
        $contentBlock2,
        $contentBlock1,
        'content-tabs__tab--active'
      );
    }
  },
  unload: function unload($section) {
    $('.content-tabs__tab-1').off();
    $('.content-tabs__tab-2').off();
  },
};
